function videoSearch() {
  var searchInput = document.getElementById('videoSearchInput')
  var paginated = document.getElementById('paginated-videos')
  var allVideos = document.getElementById('all-videos')
  var pagination = document.getElementById('videos-pagination')
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var searchText = this.value.toLowerCase()
      if (searchText.length > 0) {
        if (paginated) {
          paginated.style.display = 'none'
          paginated.setAttribute('aria-hidden', 'true')
        }
        if (pagination) pagination.style.display = 'none'
        if (allVideos) {
          allVideos.style.display = ''
          allVideos.setAttribute('aria-hidden', 'false')
        }
        var posts = allVideos.querySelectorAll('a[data-name]')
        posts.forEach(function (post) {
          var title = (post.getAttribute('data-name') || '').toLowerCase()
          var info = (post.getAttribute('data-info') || '').toLowerCase()
          var cat = (post.getAttribute('data-category') || '').toLowerCase()
          if (title.includes(searchText) || info.includes(searchText) || cat.includes(searchText)) {
            post.style.display = 'block'
            post.setAttribute('aria-hidden', 'false')
            post.removeAttribute('tabindex')
          } else {
            post.style.display = 'none'
            post.setAttribute('aria-hidden', 'true')
            post.setAttribute('tabindex', '-1')
          }
        })
      } else {
        if (paginated) {
          paginated.style.display = ''
          paginated.setAttribute('aria-hidden', 'false')
        }
        if (pagination) pagination.style.display = ''
        if (allVideos) {
          allVideos.style.display = 'none'
          allVideos.setAttribute('aria-hidden', 'true')
        }
      }
    })
  }
}
export default videoSearch
